import AbstractFilterControl from "./AbstractFilterControl";

import type { Attribute } from "@esWebAPI/es/model/Feature";
import type { Criteria } from "@esWebAPI/es/model/Criteria";
import type LayerViewModel from "@esWebAPI/es/map/LayerViewModel";

export default abstract class AbstractSpatialFilterControl extends AbstractFilterControl {
    constructor(layerViewModel: LayerViewModel, type: string, title?: string) {
        super(layerViewModel, type, title);
    }

    isSpatial(): boolean {
        return true;
    }

    // Useful auxiliary method to be used by children
    protected generateUniqName(prefix?: string) {
        var uniqSuffix = Date.now().toString(26).toUpperCase();
        return (prefix ? prefix + "_" + uniqSuffix : uniqSuffix);
    }

    setGeometry(obj: Criteria | Attribute, geoShapeKey: string | undefined, geometry: any[] | undefined) {
        if (geoShapeKey) {
            obj.geoShapeKey = geoShapeKey;
        } else {
            obj.geometry = geometry;
        }
    }
}